// Monday the 2nd of December, 23:59 Los Angeles Time
export const BLACK_FRIDAY_CAMPAIGN_END = Date.UTC(
  new Date().getFullYear(),
  11,
  3,
  7,
  59,
  59,
)

export const BLACK_FRIDAY_DISCOUNT = 0
